import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import '@scuf/common/honeywell/theme.css';
import '@scuf/datatable/honeywell-combined/theme.css';
import './styles/app-global.scss';
import '@fortawesome/fontawesome-free/css/all.css';
import { ThemeType, toggleTheme } from '@scuf/common'; 
import { Provider } from 'react-redux';
import { store } from './store';


// To set the view to dark theme
toggleTheme(ThemeType.Light);
const wrappedApp = (
    <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

ReactDOM.render(wrappedApp, document.getElementById('root') as HTMLElement);